import {
  Autocomplete,
  Box,
  Paper,
  Stack,
  styled,
  TextField,
} from "@mui/material";
import React, { useEffect } from "react";
import {
  FontStyle,
  QuestionData,
  defaultBottomPadding,
  roleTitles,
  roleCutoffs,
  defaultInnerStyle,
  defaultContainerStyle,
} from "../../constants";
import CheckButton from "../CheckButton";
import HeartButton from "../HeartButton";
import SimpleButton from "../SimpleButton";
import TempDisplay from "../TempDisplay";

const styles = {
  container: {
    width: "100%",
    height: "100%",
    paddingTop: "2rem",
    paddingBottom: defaultBottomPadding,
  },
  inner: {
    ...defaultInnerStyle,
  },
  body: {
    ...FontStyle.body,
    fontSize: "1rem",
    textAlign: "center",
    lineHeight: "1.4",
    maxWidth: "500px",
  },
  search: {
    width: "100%",
    maxWidth: "500px",
    backgroundColor: "rgb(255, 255, 255)",
    borderRadius: "4px",
    border: "1px solid rgb(204, 204, 204)",
  },
};

const numNeeded = 1;
const numMax = 5;
const numTitles = roleTitles.length;
const cutoffs = roleCutoffs;

const Q5_Roles = ({
  selected,
  setSelected,
  setQuestionsDone,
  questionNum,
  options,
  setRefreshCount,
}) => {
  const [titles, setTitles] = React.useState([]);
  const [extraValues, setExtraValues] = React.useState([]);
  useEffect(() => {
    const newExtraValues = [];
    titles.forEach((titleIdx, i) => {
      newExtraValues.push(
        ...options.slice(
          numTitles + cutoffs[titleIdx],
          numTitles + cutoffs[titleIdx + 1]
        )
      );
    });
    setExtraValues(newExtraValues);
  }, [titles]);
  useEffect(() => {
    setRefreshCount((prev) => prev + 1);
  }, [extraValues]);
  useEffect(() => {
    const relevant = selected[questionNum].filter((i) => i >= numTitles);
    if (relevant.length >= numNeeded && relevant.length <= numMax) {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: true }));
    } else {
      setQuestionsDone((prev) => ({ ...prev, [questionNum]: false }));
    }

    // when selected is loaded from existing user data, set titles
    const newTitles = [];
    selected[questionNum].forEach((i) => {
      if (i < numTitles) {
        newTitles.push(i);
      }
    });
    setTitles(newTitles);
  }, [selected]);
  return (
    <Stack
      direction="column"
      sx={styles.container}
      alignItems="center"
      spacing={4}>
      {/* <TempDisplay
        selected={selected}
        options={options}
        questionNum={questionNum}
      /> */}
      <Stack
        direction="row"
        sx={styles.inner}
        alignItems="center"
        justifyContent="center"
        flexWrap="wrap"
        spacing={0}
        gap={1}>
        {options.slice(0, numTitles).map((option, i) => {
          return (
            <HeartButton
              key={i}
              text={option}
              selected={selected[questionNum].includes(i)}
              setSelected={() => {
                if (selected[questionNum].includes(i)) {
                  setSelected((s) => {
                    const startRemoveIdx = numTitles + cutoffs[i];
                    const endRemoveIdx = numTitles + cutoffs[i + 1];
                    return {
                      ...s,
                      [questionNum]: s[questionNum].filter(
                        (item) =>
                          (item !== i && item < startRemoveIdx) ||
                          item >= endRemoveIdx
                      ),
                    };
                  });
                  setTitles((t) => t.filter((item) => item !== i));
                } else {
                  setSelected((s) => {
                    return { ...s, [questionNum]: [...s[questionNum], i] };
                  });
                  setTitles((t) => [...t, i]);
                }
              }}
            />
          );
        })}
      </Stack>
      <Stack
        direction="column"
        sx={styles.inner}
        alignItems="center"
        justifyContent="center"
        spacing={1}>
        {extraValues.length > 0 && (
          <Box sx={styles.body}>
            {selected[questionNum].filter((i) => i >= numTitles).length === 0
              ? `Choose up to ${numMax} roles`
              : `Choose up to ${
                  numMax -
                  selected[questionNum].filter((i) => i >= numTitles).length
                } more`}
          </Box>
        )}
        {options
          .filter((option, idx) => extraValues.includes(option))
          .map((option, idx) => {
            const i = options.indexOf(option);
            return (
              <CheckButton
                key={i}
                text={option}
                selected={selected[questionNum].includes(i)}
                setSelected={() => {
                  if (selected[questionNum].includes(i)) {
                    setSelected((s) => {
                      return {
                        ...s,
                        [questionNum]: s[questionNum].filter(
                          (item) => item !== i
                        ),
                      };
                    });
                  } else if (
                    selected[questionNum].filter((i) => i >= numTitles).length <
                    numMax
                  ) {
                    setSelected((s) => {
                      return { ...s, [questionNum]: [...s[questionNum], i] };
                    });
                  }
                }}
                disabled={
                  selected[questionNum].filter((i) => i >= numTitles).length >=
                    numMax && !selected[questionNum].includes(i)
                }
              />
            );
          })}
      </Stack>
    </Stack>
  );
};
const CustomPaper = (props) => {
  return (
    <Paper
      elevation={0}
      {...props}
      sx={{
        my: 1,
        border: "1px solid rgb(204, 204, 204)",
      }}
    />
  );
};

export default Q5_Roles;
